import { IdValue } from '../../../shared/models/id-value.model';

export const tridSummariesOfTransactionSection: IdValue[] = [
  new IdValue(0, 'DueFromBor', 'Due from Borrower'),
  new IdValue(1, 'DueToSeller', 'Due to Seller'),
  new IdValue(2, 'PaidByOrOnBehalfOfBor', 'Paid by or on behalf of Borrower'),
  new IdValue(3, 'DueFromSeller', 'Due from Seller'),
];

export const landValueTypes: IdValue[] = [
  new IdValue(0, 'OmitLandValue', 'Omit Land Value'),
  new IdValue(1, 'AppraisedValueOfLot', 'Appraised Value of Lot'),
  new IdValue(2, 'OriginalCostOfLot', 'Original Cost of Lot'),
];
